import React from 'react';
import { Grid } from '@material-ui/core';
import classnames from 'classnames';

import { Card } from 'core/components/card';
import AlertIconWhite from 'core/assets/svg/alert-white.svg';
import CheckIconWhite from 'core/assets/svg/check-white.svg';
import useStyles from './banner.styles';

const ICONS = {
  alert: AlertIconWhite,
  check: CheckIconWhite
};

// A hidden banner renders nothing. It used to stay mounted at height 0, which looked hidden but left its
// message and buttons readable by screen readers, reachable with Tab, and present in e2e page snapshots:
// every staff session "showed" the impersonation and agency-claims banners there (#36257).
function Banner({ color, children, show, iconType }) {
  const classes = useStyles();
  if (!show) {
    return null;
  }
  const icon = ICONS[iconType];
  return (
    <Card className={classnames(classes.bannerShow, classes[color])}>
      <Grid container alignItems="center">
        <img src={icon} className={classes.icon} alt="Banner Icon" />
        <Grid container alignItems="center" className={classes.bannerContent}>
          {children}
        </Grid>
      </Grid>
    </Card>
  );
}

export default Banner;
